import { Flex, Typography } from '@aloft/toolkit-sui';

import { selectDepreciationSegments } from '../../../../redux/features/selectors/selectDepreciationSegments.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { RootState } from '../../../../redux/types.ts';
import { EffectiveAgeSeparateDepreciationTableRow } from '../DepreciateSeparately/EffectiveAgeSeparateDepreciationTableRow.tsx';

export const EffectiveAgeSeparateDepreciationTable = ({ id }: { id: string }) => {
  const segments = useAppSelector((state: RootState) => selectDepreciationSegments(state, id));

  return (
    <Flex flexDirection="column" gap=".25rem" marginTop="1rem" marginBottom="1rem">
      <Flex justifyContent="space-between">
        <Typography variant="h4" color="textSecondary">
          Additional Structures
        </Typography>
        <Typography variant="h4" color="textSecondary">
          Age/Life
        </Typography>
      </Flex>
      {segments.map((segment, idx) => (
        <EffectiveAgeSeparateDepreciationTableRow
          key={`${segment.label}=${idx}`}
          id={id}
          segment={segment}
        />
      ))}
    </Flex>
  );
};
